var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupExplorer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "groupExplorer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "folder",
    d: "M19,3H12.472a1.019,1.019,0,0,1-.447-.1L8.869,1.316A3.014,3.014,0,0,0,7.528,1H5A5.006,5.006,0,0,0,0,6V18a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V8a5.006,5.006,0,0,0-5-5ZM5,3H7.528a1.019,1.019,0,0,1,.447.1l3.156,1.579A3.014,3.014,0,0,0,12.472,5H19a3,3,0,0,1,2.779,1.882L2,6.994V6A3,3,0,0,1,5,3ZM19,21H5a3,3,0,0,1-3-3V8.994l20-.113V18A3,3,0,0,1,19,21Z",
    transform: "translate(0 -1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "users",
    d: "M3.173,5.5a1.9,1.9,0,1,1,1.9-1.9,1.9,1.9,0,0,1-1.9,1.9Zm0-2.961A1.058,1.058,0,1,0,4.23,3.6,1.058,1.058,0,0,0,3.173,2.538ZM6.345,8.46A2.118,2.118,0,0,0,4.23,6.345H2.115A2.118,2.118,0,0,0,0,8.46v1.692H.846V8.46A1.269,1.269,0,0,1,2.115,7.191H4.23A1.269,1.269,0,0,1,5.5,8.46v1.692h.846ZM7.4,3.807a1.9,1.9,0,1,1,1.9-1.9,1.9,1.9,0,0,1-1.9,1.9ZM7.4.846A1.058,1.058,0,1,0,8.46,1.9,1.058,1.058,0,0,0,7.4.846Zm2.75,5.922A2.118,2.118,0,0,0,8.037,4.653H6.345V5.5H8.037A1.269,1.269,0,0,1,9.306,6.768V8.46h.846Z",
    transform: "translate(6.924 8.848)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupExplorer);
export default __webpack_public_path__ + "static/media/groupExplorer.b82899b7eb66b33f94b678390fc0d793.svg";
export { ForwardRef as ReactComponent };